var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWarningImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 98,
    viewBox: "0 0 85 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4494,
    cy: 28.5505,
    r: 28.5505,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7032 16.4222H42.6032V16.5222V37.142V37.242H42.7032H56.3498V40.4786H42.7032C40.8632 40.4786 39.3666 38.9821 39.3666 37.142V16.5222C39.3666 14.6821 40.8632 13.1856 42.7032 13.1856H65.0414C66.8814 13.1856 68.378 14.6821 68.378 16.5222V28.4504H65.1414V16.5222V16.4222H65.0414H42.7032Z",
    fill: "#565656",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1365 33.6054H44.6219L49.5597 27.0216L51.2057 30.3135L51.2781 30.4582L51.3751 30.3288L56.4453 23.5686L63.1365 33.6054Z",
    fill: "#565656",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0417 37.242H65.1417V37.142V32.0871H68.3783V37.142V37.242H68.4783H73.5333V40.4786H68.4783H68.3783V40.5786V45.6336H65.1417V40.5786V40.4786H65.0417H59.9867V37.242H65.0417Z",
    fill: "#565656",
    stroke: "white",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9289 97.4598H9.38408C2.4171 97.4598 -2.11415 90.125 1.00147 83.8912L23.7739 38.328C27.2276 31.4175 37.0852 31.4175 40.539 38.328L63.3113 83.8911C66.4272 90.1249 61.896 97.4598 54.9289 97.4598Z",
    fill: "url(#paint0_linear_14529_189095)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9289 97.4598H9.38408C2.4171 97.4598 -2.11415 90.125 1.00147 83.8912L23.7739 38.328C27.2276 31.4175 37.0852 31.4175 40.539 38.328L63.3113 83.8911C66.4272 90.1249 61.896 97.4598 54.9289 97.4598Z",
    fill: "#FFC107"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0554 85.0193L38.2831 39.4561C37.0976 37.0842 34.8072 35.6681 32.1563 35.6681C29.5055 35.6681 27.2152 37.0842 26.0296 39.4561L3.25728 85.0193C2.18781 87.1591 2.29984 89.6516 3.55709 91.6865C4.81433 93.7216 6.99272 94.9367 9.38394 94.9367H54.9288C57.32 94.9367 59.4984 93.7216 60.7557 91.6865C62.0128 89.6516 62.1249 87.1592 61.0554 85.0193ZM58.6103 90.36C57.8159 91.6458 56.4397 92.4135 54.9289 92.4135H9.38394C7.87312 92.4135 6.49671 91.6458 5.70252 90.36C4.90811 89.0744 4.83734 87.4995 5.51313 86.1475L28.2854 40.5846C29.0456 39.0636 30.4563 38.1913 32.1562 38.1913C33.8561 38.1913 35.267 39.0636 36.027 40.5846L58.7993 86.1478C59.4753 87.4995 59.4046 89.0744 58.6103 90.36Z",
    fill: "#FFD761"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6592 84.4938C28.6592 83.617 29.0167 82.8723 29.7316 82.2594C30.4466 81.6461 31.3155 81.3388 32.3369 81.3388C33.2365 81.3388 34.014 81.6461 34.6697 82.2594C35.3255 82.8723 35.6545 83.617 35.6545 84.4938C35.6545 85.3352 35.3257 86.0712 34.6697 86.702C34.014 87.3331 33.2363 87.6485 32.3369 87.6485C31.3154 87.6485 30.4466 87.333 29.7316 86.702C29.0167 86.0712 28.6592 85.3354 28.6592 84.4938ZM29.0032 53.6043C29.0032 52.7114 29.3068 52.0218 29.9144 51.536C30.5217 51.0502 31.3083 50.807 32.2742 50.807C33.24 50.807 33.9496 51.0599 34.402 51.5654C34.8543 52.0708 35.081 52.7503 35.081 53.6043C35.081 56.4026 35.0325 57.7025 34.9376 64.0353C34.8418 70.3682 34.7945 72.3637 34.7945 75.161C34.7945 75.7448 34.5212 76.2016 33.9757 76.5314C33.4291 76.8612 32.862 77.0264 32.2743 77.0264C30.5524 77.0264 29.6914 76.4051 29.6914 75.1611C29.6914 72.3638 29.5765 70.3683 29.3473 64.0354C29.1177 57.7024 29.0032 56.4025 29.0032 53.6043Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14529_189095",
    x1: 16.1306,
    y1: 60.6526,
    x2: 89.524,
    y2: 134.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarningImages);
export default __webpack_public_path__ + "static/media/icons-warning-images.e96788ba823b68155703ac1891da111c.svg";
export { ForwardRef as ReactComponent };